import AbstractModalView from './AbstractModalView';

export default AbstractModalView;
